(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["size-guide-page"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialiseConverters = (scope = document) => {
    scope.querySelectorAll('[data-size-converter]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.hidden = false;
      const input = form.querySelector('[data-fit-value]');
      const unit = form.querySelector('[data-fit-unit]');
      const result = form.querySelector('[data-fit-result]');
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
      const convert = () => {
        const value = input.valueAsNumber;
        result.textContent = Number.isFinite(value) && value > 0 ? `${format.format(value)} ${unit.value} = ${format.format(unit.value === 'cm' ? value / 2.54 : value * 2.54)} ${unit.value === 'cm' ? 'in' : 'cm'}` : '';
      };
      input.addEventListener('input', convert);
      unit.addEventListener('change', convert);
      form.addEventListener('submit', (event) => { event.preventDefault(); convert(); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseConverters());
  else initialiseConverters();
  document.addEventListener('shopify:section:load', (event) => initialiseConverters(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
